// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photo-carousel-wrapper {
  position: relative;
  background: #000000b8;
  z-index: 2;
}

  .photo-carousel-wrapper .photo-carousel,
  .photo-carousel-wrapper .ant-spin.spinner,
  .photo-carousel-wrapper .ant-spin-nested-loading,
  .photo-carousel-wrapper .ant-spin-container,
  .photo-carousel-wrapper .ant-carousel {
    width: 100%;
    height: 100%;
  }

  .photo-carousel-wrapper .ant-carousel {
    position: relative;
  }

  .photo-carousel-wrapper .ant-carousel .slick-track,
    .photo-carousel-wrapper .ant-carousel .slick-list {
      height: 100%;
    }

  .photo-carousel-wrapper .ant-carousel .slick-arrow,
    .photo-carousel-wrapper .ant-carousel .slick-arrow:hover {
      font-size: 1rem;
      z-index: 3;
      color: #ffffff;
    }

  .photo-carousel-wrapper .ant-carousel .slick-arrow.slick-next, .photo-carousel-wrapper .ant-carousel .slick-arrow:hover.slick-next {
        right: 1rem;
      }

  .photo-carousel-wrapper .ant-carousel .slick-arrow.slick-prev, .photo-carousel-wrapper .ant-carousel .slick-arrow:hover.slick-prev {
        left: 1rem;
      }

  .photo-carousel-wrapper .ant-carousel .photo-carousel {
      box-sizing: border-box;
    }

  .photo-carousel-wrapper .ant-carousel .photo-carousel .image-preview {
        position: relative;
        line-height: 0;
        height: 100%;
        width: 100%;
      }

  .photo-carousel-wrapper .ant-carousel .photo-carousel .slick-slide > div {
        height: 100%;
        min-height: 100%;
      }

  .photo-carousel-wrapper .ant-carousel .photo-carousel .slick-slide > div .photo-carousel-image-wrapper {
          box-sizing: border-box;
          height: 100%;
          width: 100%;
          overflow: hidden;
        }

  .photo-carousel-wrapper .ant-carousel .photo-carousel .slick-slide > div .photo-carousel-image-wrapper img.ant-image-img {
            -o-object-fit: cover;
               object-fit: cover;
            -o-object-position: center;
               object-position: center;
            width: 100%;
            height: 100%;
          }

  .photo-carousel-wrapper.fullscreen {
    width: 100% !important;
    height: 100% !important;
    position: fixed;
    transform: translate3d(0, 0, 0);
    z-index: 10000;
    top: 0;
    left: 0;
  }

  .photo-carousel-wrapper.fullscreen .ant-carousel .slick-arrow {
      --ant-carousel-arrow-size: 3rem;
    }

  .photo-carousel-wrapper.fullscreen .ant-carousel .photo-carousel {
      height: 100% !important;
      width: 100% !important;
    }

  .photo-carousel-wrapper.fullscreen .ant-carousel .photo-carousel .slick-slide > div .photo-carousel-image-wrapper {
        padding: 1rem 0;
      }

  .photo-carousel-wrapper.fullscreen .ant-carousel .photo-carousel .slick-slide > div .photo-carousel-image-wrapper img.ant-image-img {
          -o-object-fit: scale-down;
             object-fit: scale-down;
          -o-object-position: center;
             object-position: center;
        }

  .photo-carousel-wrapper .close-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: #ffffff;
    cursor: pointer;
    font-size: 2rem;
    opacity: 0.7;
    z-index: 3;
  }

  .photo-carousel-wrapper .close-button:hover {
      opacity: 1;
    }

  .photo-carousel-wrapper .preview-cover {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ant-color-text-light-solid);
    background: rgba(0, 0, 0, 0.3);
    cursor: pointer;
    opacity: 0;
    transition: opacity var(--ant-motion-duration-slow);
  }

  .photo-carousel-wrapper .preview-cover:hover {
      opacity: 1;
    }

  .photo-carousel-wrapper .preview-cover .mask {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
    }
`, "",{"version":3,"sources":["webpack://./src/components/PhotoCarousel/style.scss"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,qBAA8B;EAC9B,UAAU;AAmIZ;;EAjIE;;;;;IAKE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EAmDpB;;EAjDE;;MAEE,YAAY;IACd;;EAEA;;MAEE,eAAe;MACf,UAAU;MACV,cAAa;IASf;;EAPE;QACE,WAAW;MACb;;EAEA;QACE,UAAU;MACZ;;EAGF;MACE,sBAAsB;IA2BxB;;EAzBE;QACE,kBAAkB;QAClB,cAAc;QACd,YAAY;QACZ,WAAW;MACb;;EAEA;QACE,YAAY;QACZ,gBAAgB;MAelB;;EAbE;UACE,sBAAsB;UACtB,YAAY;UACZ,WAAW;UACX,gBAAgB;QAQlB;;EANE;YACE,oBAAiB;eAAjB,iBAAiB;YACjB,0BAAuB;eAAvB,uBAAuB;YACvB,WAAW;YACX,YAAY;UACd;;EAMR;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,+BAA+B;IAC/B,cAAc;IACd,MAAM;IACN,OAAO;EAmBT;;EAjBE;MACE,+BAA+B;IACjC;;EAEA;MACE,uBAAuB;MACvB,sBAAsB;IAUxB;;EARE;QACE,eAAe;MAMjB;;EAJE;UACE,yBAAsB;aAAtB,sBAAsB;UACtB,0BAAuB;aAAvB,uBAAuB;QACzB;;EAKN;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAa;IACb,eAAe;IACf,eAAe;IACf,YAAY;IACZ,UAAU;EAKZ;;EAHE;MACE,UAAU;IACZ;;EAGF;IACE,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,mDAAmD;EAYrD;;EAVE;MACE,UAAU;IACZ;;EAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,QAAQ;IACV","sourcesContent":["@import '../../../assets/scss/variables.scss';\n\n.photo-carousel-wrapper {\n  position: relative;\n  background: $black-transparent;\n  z-index: 2;\n\n  & .photo-carousel,\n  .ant-spin.spinner,\n  .ant-spin-nested-loading,\n  .ant-spin-container,\n  .ant-carousel {\n    width: 100%;\n    height: 100%;\n  }\n\n  & .ant-carousel {\n    position: relative;\n\n    & .slick-track,\n    .slick-list {\n      height: 100%;\n    }\n\n    & .slick-arrow,\n    .slick-arrow:hover {\n      font-size: 1rem;\n      z-index: 3;\n      color: $white;\n\n      &.slick-next {\n        right: 1rem;\n      }\n\n      &.slick-prev {\n        left: 1rem;\n      }\n    }\n\n    .photo-carousel {\n      box-sizing: border-box;\n\n      & .image-preview {\n        position: relative;\n        line-height: 0;\n        height: 100%;\n        width: 100%;\n      }\n\n      & .slick-slide > div {\n        height: 100%;\n        min-height: 100%;\n\n        & .photo-carousel-image-wrapper {\n          box-sizing: border-box;\n          height: 100%;\n          width: 100%;\n          overflow: hidden;\n\n          & img.ant-image-img {\n            object-fit: cover;\n            object-position: center;\n            width: 100%;\n            height: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  &.fullscreen {\n    width: 100% !important;\n    height: 100% !important;\n    position: fixed;\n    transform: translate3d(0, 0, 0);\n    z-index: 10000;\n    top: 0;\n    left: 0;\n\n    & .ant-carousel .slick-arrow {\n      --ant-carousel-arrow-size: 3rem;\n    }\n\n    & .ant-carousel .photo-carousel {\n      height: 100% !important;\n      width: 100% !important;\n\n      & .slick-slide > div .photo-carousel-image-wrapper {\n        padding: 1rem 0;\n\n        & img.ant-image-img {\n          object-fit: scale-down;\n          object-position: center;\n        }\n      }\n    }\n  }\n\n  & .close-button {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    color: $white;\n    cursor: pointer;\n    font-size: 2rem;\n    opacity: 0.7;\n    z-index: 3;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  & .preview-cover {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--ant-color-text-light-solid);\n    background: rgba(0, 0, 0, 0.3);\n    cursor: pointer;\n    opacity: 0;\n    transition: opacity var(--ant-motion-duration-slow);\n\n    &:hover {\n      opacity: 1;\n    }\n\n    & .mask {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
